var wizard = {
	$this: $( '.js-wizard' ),
	$bg: $( '.js-filter .wizard-bg' ),
	$inner: $( '.js-wizard-inner' ),
	$btn: $( '.js-open-wizard' ),
	$close: $( '.js-wizard .js-close' ),
	$questions: $( '.js-wizard .wizard-questions-inner' ),
	$submit: $( '.js-wizard .wizard-submit' ),
	active: false,
	setScrollTop: 0,
	checkIfLastQ: function() {
		wizard.checkIfResults( function() {
			if ( $( '.wizard-q').length == $( '.wizard-q.is-complete' ).length ) {
				wizard.$submit.removeClass( 'is-hidden' );
				wizard.generateResultUrl();
			}
		});
	},
	checkIfResults: function( callback ) {
		var form_data = {};
		wizard.$this.find( '.wizard-q.is-complete' ).each(function(){
			if ( 'undefined' != typeof $(this).find('.select').attr('name') ) {
				form_data[ $(this).find('.select').attr('name') ] = $(this).find('.select').val();
			}
		});
		if ( 3 == Object.keys(form_data).length ) {
			wizard.$this.find('.wizard-submit, .wizard-error').addClass('is-hidden').removeClass('is-active');
			$.ajax({
				url: customData.ajaxURL,
				data: { action : 'kom_get_course_wizard_results', q : form_data },
				method: 'post',
				asynch: false,
				cache: false,
			})
			.success( function(thisdata, textStatus, jqCHR) {
				var json = $.parseJSON( thisdata );

				wizard.$this.find('.wizard-submit .total').text( json.count );

				if ( json.count > 0 ) {
					wizard.$this.find('.wizard-submit').addClass('is-active');
					if (typeof(callback) == 'function') {
						callback();
					}
				} else {
					wizard.$this.find('.wizard-error').removeClass('is-hidden').addClass('is-active');
				}
			});
		} else {
			if (typeof(callback) == 'function') {
				callback();
			}
		}
	},
	nextQuestion: function( $q ) {
		$q.addClass( 'is-complete' ).next( '.wizard-q, .wizard-submit' ).removeClass( 'is-hidden' ).addClass( 'is-active' );
		var countActives = $( '.wizard-q.is-active' ).length +1;
		var transform = wizard.helpers.getTransform( 'translate3d( 0, -'+ 35 * countActives +'px, 0 )' );
		wizard.$questions.css( transform );
		wizard.checkIfLastQ();
	},
	changeQuestions: function( $selected, callback ) {
		var questions = customData.wizardQuestions;
		if ( 'undefined' != typeof questions ) {
			var $q = 0;
			wizard.$this.find('.wizard-q:gt(0)').each(function(){
				//$(this).find('.q:first').text();
				$(this).find('.q:first').text( customData.wizardQuestions[ $selected ][ $q ] );
				$q++;
			});
		}
		setTimeout(function(){
			if (typeof(callback) == 'function') {
				callback();
			}
		},100);
	},
	generateResultUrl: function() {
		var $link = [];

		wizard.$this.find( '.wizard-q.is-complete' ).each(function(){
			$link[ $link.length ] = $(this).find('.select').val();
		});

		var $href = '#';
		if ( $link.length > 0 ) {
			$href = customData.courseArchive + '?filter=[' + $link.join(',') + ']';
		}

		wizard.$submit.find('a').attr('href', $href );
	},
	close: function() {
		wizard.$this.removeClass( 'active' );
		setTimeout( function() {
			wizard.$bg.removeAttr('style');
			$( 'body' ).removeClass( 'fixed' );
			$( '#container' ).removeAttr( 'style' );
			$( window ).scrollTop( wizard.setScrollTop );
			$( '.filter-spacer' ).removeClass( 'zIndex' );
			wizard.active = false;
		}, 500 );
	},
	open: function() {
		if ( !wizard.active ) {
			wizard.setScrollTop = $(window).scrollTop();
			$( 'body' ).addClass( 'fixed' );
			$( '#container' ).css( { 'position': 'fixed', 'margin-top': -Math.abs(wizard.setScrollTop) } );
			// open wizard bg:
			$( '.filter-spacer' ).addClass( 'zIndex' );
			wizard.$bg.css( { 'z-index': '998', 'transform': 'scale(80)', 'opacity': 1, 'visibility': 'visible' });
			// show wizard content:
			setTimeout(function() {
				wizard.$this.addClass( 'active' );
				wizard.active = true;
				wizard.helpers.selectSelect();
			}, 500);
		}
	},
	helpers: {
		getTransform(transform) {
			return {
				'-webkit-transform': transform,
				'-moz-transform': transform,
				'-ms-transform': transform,
				'transform': transform
			};
		},
		selectSelect() {
			wizard.$this.find( '.select' ).change( function() {
				var $select = $( this );
				var set_value = $select.closest('select').find('option:selected').text();
				$select.parents( '.wizard-q' ).find( 'span.empty' ).text( set_value );

				if ( $select.closest('.wizard-q').index() < 1 ) {
					wizard.changeQuestions( $select.val(), function() {
						// wait until finished
						wizard.nextQuestion( $select.parents( '.wizard-q') );
					});
				} else {
					wizard.nextQuestion( $select.parents( '.wizard-q') );
				}
			} );
		},
	},
	init: function() {
		if ( wizard.$this.length > 0 ) {
			wizard.$btn.on( 'click', function( e ) {
				e.preventDefault();
				wizard.open();
			} );
			wizard.$close.on( 'click', function( e ) {
				e.preventDefault();
				wizard.close();
			} );
		}
	},
};
